export default __webpack_public_path__ + "static/media/tree.8ef7c0e0.svg";